import { createTheme } from '@mui/material/styles';

const orinishikiTheme = createTheme({
  palette: {
    primary: {
      main: '#b8956b',
      light: '#CCAD89',
      dark: '#8b7355',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#3d3630',
      light: '#5A514A',
      dark: '#2A2420',
      contrastText: '#ffffff',
    },
    background: {
      default: '#fdfbf7',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#3d3630',
      secondary: '#7a7067',
    },
    divider: '#e8e0d0',
  },
  typography: {
    fontFamily: '"Noto Sans JP", "Helvetica Neue", Arial, sans-serif',
    h1: {
      fontFamily: '"Noto Serif JP", "Noto Sans JP", serif',
      fontWeight: 500,
      letterSpacing: '0.06em',
      lineHeight: 1.7,
    },
    h2: {
      fontFamily: '"Noto Serif JP", "Noto Sans JP", serif',
      fontWeight: 400,
      letterSpacing: '0.06em',
      lineHeight: 1.6,
    },
    h3: {
      fontFamily: '"Noto Serif JP", "Noto Sans JP", serif',
      fontWeight: 500,
      letterSpacing: '0.05em',
      lineHeight: 1.6,
    },
    h4: {
      fontFamily: '"Noto Serif JP", "Noto Sans JP", serif',
      fontWeight: 500,
      letterSpacing: '0.04em',
    },
    h5: {
      fontWeight: 500,
      letterSpacing: '0.04em',
    },
    h6: {
      fontWeight: 500,
      letterSpacing: '0.04em',
    },
    body1: {
      fontSize: '0.9375rem',
      lineHeight: 2,
      letterSpacing: '0.04em',
    },
    body2: {
      fontSize: '0.875rem',
      lineHeight: 1.9,
      letterSpacing: '0.04em',
    },
    button: {
      letterSpacing: '0.1em',
      fontWeight: 500,
    },
  },
  shape: {
    borderRadius: 4,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 2,
          padding: '12px 32px',
          fontSize: '0.875rem',
        },
        containedPrimary: {
          '&:hover': {
            backgroundColor: '#8b7355',
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: 'transparent',
          boxShadow: 'none',
        },
      },
    },
  },
});

export default orinishikiTheme;
